import { observer } from 'mobx-react-lite';
import { JSX } from 'react';

import { useGlobal } from '~/hooks/useGlobal';

import SearchResultsDesktop from './components/Desktop';
import SearchResultsMobile from './components/Mobile';

const SearchResultsV3 = observer((): JSX.Element => {
  const { isMobile } = useGlobal();

  if (isMobile) {
    return <SearchResultsMobile />;
  }

  return <SearchResultsDesktop />;
});

export default SearchResultsV3;
